// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"275b826c","290":"3c101faa","631":"89dd9aaa","637":"630218cb","886":"a923a725"}[chunkId] + ".chunk.js";
};